import styled from "styled-components";

export const VouchersGamesListTitleDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1.5rem;
    padding: 10px 4px 10px 4px;
    width: 100%;

    border-bottom-width: 4px;
    border-bottom-style: solid;
    border-bottom-color: #0e0e0e;
  
    text-align: center;
`;
